import getClientDocuments from '../../../api/clients/getClientDocuments';

// Типы файлов в карточке клиента (client_document_types): 1 — удостоверение, 2 — паспорт.
// Скан удостоверения кладёт туда сам ПКБ при добавлении клиента через eGov.
const IDENTITY_TYPE_ID = 1;
const PASSPORT_TYPE_ID = 2;

const latest = (docs, typeId) =>
  (docs || [])
    .filter((doc) => doc?.typeId === typeId && doc?.url)
    .sort((a, b) => (b.id || 0) - (a.id || 0))[0] || null;

// Какие сканы из карточки клиента подставить в поля анкеты «УДВ» и «Паспорт РК».
export const pickIdentityScans = (docs) => ({
  UDV: latest(docs, IDENTITY_TYPE_ID),
  passportRK: latest(docs, PASSPORT_TYPE_ID),
});

export const fileNameOf = (url) => decodeURIComponent(String(url || '').split('?')[0].split('/').pop() || 'document');

const downloadAsFile = async (doc) => {
  const response = await fetch(doc.url);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const blob = await response.blob();
  return new File([blob], fileNameOf(doc.url), { type: blob.type });
};

// Фотография клиента лежит не в документах, а в аватаре карточки — туда её кладёт
// ПКБ вместе с удостоверением (снимок с самого документа). Банки требуют фото в
// анкете, и менеджер искал его сам, хотя оно уже есть.
export const loadClientPhoto = async (photoUrl) => {
  if (!String(photoUrl || '').trim()) return null;
  try {
    return await downloadAsFile({ url: photoUrl });
  } catch (e) {
    return null;
  }
};

// Скачивает найденные сканы. Недоступный файл просто пропускаем: поле останется пустым,
// и менеджер загрузит документ сам, как раньше.
export const loadIdentityScans = async (clientId) => {
  const res = await getClientDocuments({ userId: clientId });
  const picked = pickIdentityScans(res?.data);
  const files = {};
  await Promise.all(
    Object.entries(picked).map(async ([field, doc]) => {
      if (!doc) return;
      try {
        files[field] = await downloadAsFile(doc);
      } catch (e) {}
    })
  );
  return files;
};
